import { memo } from 'react';
import { cn } from '../../../utils/string/cn.utils';

const ButtonIconSolidLarge = ({ id, icon, active = false, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'disabled:cursor-not-allowed disabled:pointer-events-none bg-fills-white rounded-[100px] shadow-dropshadow8 flex justify-center items-center hover:bg-primary-primaryVarient1 hover:text-white-high disabled:text-black-low disabled:bg-fills-disable text-black-high cursor-pointer',
        'gap-[10px] w-[40px] h-[40px] p-[4px] ',
        active && 'bg-primary-primary text-white-high',
        props.className,
        props.classNames?.button
      )}
    >
      {icon && (
        <div
          className={cn(
            'w-24 h-24 flex justify-center items-center',
            props.classNames?.icon
          )}
        >
          {icon}
        </div>
      )}
    </button>
  );
};

export default memo(ButtonIconSolidLarge);
